import { useEffect } from "react";
import { useParams } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PreviewPage() {
  const { projectKey } = useParams();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${BACKEND_URL}/widget.js`;
    script.setAttribute("data-project-key", projectKey);
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
      document.getElementById("tugboat-widget-root")?.remove();
    };
  }, [projectKey]);

  return (
    <div className="min-h-screen bg-cream wave-bg">
      <header className="h-16 bg-white border-b-2 border-ink flex items-center px-8">
        <span className="font-display font-700 text-xl tracking-tight">Acme Bank — Beta Preview</span>
      </header>
      <div className="max-w-4xl mx-auto p-10">
        <div className="nb-card p-8">
          <p className="label-overline mb-2">Sandbox</p>
          <h1 className="font-display text-4xl font-700 tracking-tight mb-3">This is a demo of your beta product.</h1>
          <p className="text-ink/70 mb-6 max-w-lg font-600">The Tugboat feedback button is bobbing in the bottom-right corner. Drag it anywhere, then try recording your screen, leaving a voice note, capturing a screenshot, or writing a note.</p>
          <div className="grid sm:grid-cols-3 gap-4">
            <div className="h-28 bg-teal/30 border-2 border-ink/15 rounded-2xl" />
            <div className="h-28 bg-sunny/40 border-2 border-ink/15 rounded-2xl" />
            <div className="h-28 bg-orange/20 border-2 border-ink/15 rounded-2xl" />
          </div>
          <div className="mt-4 h-40 bg-white border-2 border-ink/15 rounded-2xl" />
        </div>
      </div>
    </div>
  );
}
